import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import usePreferencesStore from '../store/usePreferencesStore';

const { FiX, FiSettings, FiCheck } = FiIcons;

const SettingsDialog = ({ isOpen, onClose }) => {
  const { 
    wallColor, setWallColor,
    wallThickness, setWallThickness,
    roomFillColor, setRoomFillColor
  } = usePreferencesStore();

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 backdrop-blur-sm">
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-md overflow-hidden">
        <div className="flex items-center justify-between p-4 border-b border-gray-100">
          <h2 className="text-lg font-bold text-gray-800 flex items-center gap-2">
            <SafeIcon icon={FiSettings} className="text-xl" />
            Ustawienia Domyślne
          </h2>
          <button onClick={onClose} className="p-2 hover:bg-gray-100 rounded-full transition-colors">
            <SafeIcon icon={FiX} />
          </button>
        </div>
        
        <div className="p-6 space-y-6">
          {/* Wall Settings */}
          <div className="space-y-4">
            <h3 className="text-sm font-semibold text-gray-500 uppercase tracking-wider">Ściany</h3>
            
            <div className="space-y-2">
              <label className="text-sm font-medium text-gray-700">Domyślna Grubość (cm)</label>
              <div className="flex items-center gap-3">
                <input 
                  type="range" 
                  min="5" 
                  max="50" 
                  value={wallThickness} 
                  onChange={(e) => setWallThickness(parseInt(e.target.value))}
                  className="flex-1 h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer accent-[#1E2937]"
                />
                <span className="w-12 text-center font-mono text-sm bg-gray-100 py-1 rounded">{wallThickness}</span>
              </div>
            </div>

            <div className="space-y-2">
              <label className="text-sm font-medium text-gray-700">Domyślny Kolor Ścian</label>
              <div className="flex items-center gap-3">
                <input 
                  type="color" 
                  value={wallColor} 
                  onChange={(e) => setWallColor(e.target.value)}
                  className="w-10 h-10 p-0.5 rounded border border-gray-300 cursor-pointer"
                />
                <span className="text-sm text-gray-600 font-mono">{wallColor}</span>
              </div>
            </div>
          </div>

          <div className="h-px bg-gray-100" />

          {/* Room Settings */}
          <div className="space-y-4">
            <h3 className="text-sm font-semibold text-gray-500 uppercase tracking-wider">Pomieszczenia</h3>
            
            <div className="space-y-2">
              <label className="text-sm font-medium text-gray-700">Domyślny Kolor Wypełnienia</label>
              <div className="flex items-center gap-3">
                <input 
                  type="color" 
                  value={roomFillColor} 
                  onChange={(e) => setRoomFillColor(e.target.value)}
                  className="w-10 h-10 p-0.5 rounded border border-gray-300 cursor-pointer"
                />
                <span className="text-sm text-gray-600 font-mono">{roomFillColor}</span>
              </div>
            </div>
          </div>
        </div>

        <div className="p-4 bg-gray-50 border-t border-gray-100 flex justify-end">
          <button 
            onClick={onClose}
            className="px-4 py-2 bg-[#1E2937] text-white rounded-lg hover:bg-gray-800 transition-colors flex items-center gap-2 font-medium"
          >
            <SafeIcon icon={FiCheck} />
            Gotowe
          </button>
        </div>
      </div>
    </div>
  );
};

export default SettingsDialog;